import React from 'react'

import WELCOME_IMAGE from '@public/assets/welcome-wizard/welcome-introduction.png'

const GettingStartedStep = () => (
  <div className="flex max-w-[900px] flex-col gap-5">
    <img
      alt="People walking together"
      className="h-[252px] w-full object-cover object-center"
      src={WELCOME_IMAGE}
    />
    <div>
      <h2 className="mb-3 text-lg font-semibold text-black">
        Capture More Billable Time. Less Effort.
      </h2>
      <p className="max-w-[900px] text-base leading-[1.35] tracking-[0.5px] text-[#666]">
        MIRA automatically captures work activities across emails, meetings,
        documents, desktop applications, and websites, then intelligently
        transforms them into draft time entries for your review.
      </p>
      <p className="mt-4 text-base leading-[1.35] tracking-[0.5px] text-[#666]">
        Before getting started, let&apos;s make sure MIRA is fully set up on
        your device.
      </p>
    </div>
  </div>
)

export default GettingStartedStep
